<template>
    <div class="profile__container--valueForms">
	    <form v-bind:action="submitUrl" accept-charset="UTF-8" method="get">
	        <input type="hidden" name="authenticity_token" v-bind:value="formToken">


		    <div class="profile__container--wrapper profile__container--columns-2">
	            <div class="profile__container--outer candidate-details sectioned">
	                <div class="profile__container--header">
	                    <h3>Companies with CVs</h3>
	                </div>
	                <div class="profile__container--main">
	                    <div class="form-hint">Export the last 3 positions of the candidates registered in the selected period</div>

			            <form-field
		                    title="Period"
		                    fieldtype="form-date"
		                    inputname="exports[selected_period]"
		                    v-bind:ismonthselect='true'
		                    v-bind:startvalue="record.selected_period"
		                ></form-field>


	                    <button 
	                        type="submit" 
	                        name="export"
	                        value="xlsx"
	                        class="submit-button" 
	                        v-bind:disabled="submitIsDisabled"
	                    > 
	                        Export
	                    </button>
	                </div>
	            </div>
	        </div>
	    </form>
    </div>
</template>

<script>
    import FormField from './../../form-field/form-field.vue'

    export default {
        props: [
            'recordData',
            'formOptionsData'
        ],
        data: function(){
        	var record = JSON.parse(this.recordData || '{}');
            var formOptions = JSON.parse(this.formOptionsData || '{}');

            return { 
                submitUrl: formOptions.submit_url, 
                formToken: formOptions.form_token,
                submitIsDisabled: formOptions.submit_is_disabled,
            	record: record, 
            	formOptions: formOptions

            };
        },
        components: {
            FormField
        }
    }
</script>

